"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.networkframeproptypes = exports.ordinalframeproptypes = exports.xyframeproptypes = exports.networkFrameChangeProps = exports.orFrameChangeProps = exports.xyFrameChangeProps = exports.xyFrameDataProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _sharedframeproptypes, _extends2;

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //size is a special case and handled checking the actual values in the size array


var xyFrameDataProps = exports.xyFrameDataProps = ["lines", "points", "areas", "xScaleType", "yScaleType", "xAccessor", "yAccessor", "lineDataAccessor", "areaDataAccessor", "lineType", "showLinePoints", "defined"];

var xyFrameChangeProps = exports.xyFrameChangeProps = [].concat(xyFrameDataProps, ["name", "title", "margin", "axes", "position", "xExtent", "yExtent", "invertX", "invertY", "hoverAnnotation", "additionalDefs", "defined", "lineStyle", "pointStyle", "areaStyle", "lineClass", "pointClass", "areaClass", "canvasPoints", "customPointMark", "customLineMark", "lineIDAccessor"]);

var orFrameChangeProps = exports.orFrameChangeProps = ["data", "name", "orient", "title", "margin", "format", "position", "oScaleType", "rScaleType", "oExtent", "rExtent", "invertO", "invertR", "oAccessor", "rAccessor", "oPadding", "projection", "type", "summaryType", "connectorType", "className", "additionalDefs", "renderKey", "dataAccessor", "rBaseline", "sortO", "dynamicColumnWidth", "renderFn", "style", "connectorStyle", "summaryStyle", "summaryPosition", "oLabel", "axis"];

var networkFrameChangeProps = exports.networkFrameChangeProps = ["name", "graph", "nodes", "edges", "title", "margin", "position", "nodeIDAccessor", "sourceAccessor", "targetAccessor", "nodeSizeAccessor", "customNodeIcon", "nodeLabels", "edgeWidthAccessor", "networkType", "className", "additionalDefs", "renderFn", "nodeStyle", "edgeStyle", "edgeType"];

/*
const xyFrameOtherProps = [
  "matte",
  "tooltipContent",
  "interaction",
  "annotations",
  "svgAnnotationRules",
  "htmlAnnotationRules",
  "customHoverBehavior",
  "customClickBehavior",
  "customDoubleClickBehavior",
  "backgroundGraphics",
  "foregroundGraphics",
  "download",
  "downloadFields"
]

const orFrameOtherProps = [
  "annotations",
  "htmlAnnotationRules",
  "tooltipContent",
  "interaction",
  "customHoverBehavior",
  "customClickBehavior",
  "svgAnnotationRules",
  "hoverAnnotation",
  "backgroundGraphics",
  "foregroundGraphics"
]

const networkFrameOtherProps = [
  "annotations",
  "htmlAnnotationRules",
  "tooltipContent",
  "interaction",
  "customHoverBehavior",
  "customClickBehavior",
  "customDoubleClickBehavior",
  "svgAnnotationRules",
  "hoverAnnotation",
  "backgroundGraphics",
  "foregroundGraphics"
]
*/

var sharedframeproptypes = (_sharedframeproptypes = {
  useSpans: _propTypes2.default.bool,
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  margin: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]),
  name: _propTypes2.default.string,
  dataVersion: _propTypes2.default.string,
  frameKey: _propTypes2.default.string,
  size: _propTypes2.default.array,
  position: _propTypes2.default.array,
  canvasPostProcess: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  additionalDefs: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  className: _propTypes2.default.string,
  customHoverBehavior: _propTypes2.default.func,
  customClickBehavior: _propTypes2.default.func,
  customDoubleClickBehavior: _propTypes2.default.func,
  hoverAnnotation: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array, _propTypes2.default.func, _propTypes2.default.bool, _propTypes2.default.string]),
  disableContext: _propTypes2.default.bool,
  interaction: _propTypes2.default.object,
  svgAnnotationRules: _propTypes2.default.func,
  htmlAnnotationRules: _propTypes2.default.func,
  tooltipContent: _propTypes2.default.func,
  annotations: _propTypes2.default.array
}, _defineProperty(_sharedframeproptypes, "interaction", _propTypes2.default.object), _defineProperty(_sharedframeproptypes, "baseMarkProps", _propTypes2.default.object), _defineProperty(_sharedframeproptypes, "backgroundGraphics", _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])), _defineProperty(_sharedframeproptypes, "foregroundGraphics", _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])), _defineProperty(_sharedframeproptypes, "beforeElements", _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])), _defineProperty(_sharedframeproptypes, "afterElements", _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])), _defineProperty(_sharedframeproptypes, "download", _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])), _defineProperty(_sharedframeproptypes, "downloadFields", _propTypes2.default.array), _defineProperty(_sharedframeproptypes, "annotationSettings", _propTypes2.default.object), _defineProperty(_sharedframeproptypes, "renderKey", _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])), _defineProperty(_sharedframeproptypes, "legend", _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool])), _sharedframeproptypes);

var xyframeproptypes = exports.xyframeproptypes = _extends({}, sharedframeproptypes, {
  lines: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  points: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  areas: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  axes: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  matte: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  xScaleType: _propTypes2.default.func,
  yScaleType: _propTypes2.default.func,
  xExtent: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  yExtent: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  invertX: _propTypes2.default.bool,
  invertY: _propTypes2.default.bool,
  xAccessor: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  yAccessor: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  lineDataAccessor: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  areaDataAccessor: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  lineType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  areaType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  lineRenderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.func]),
  pointRenderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.func]),
  areaRenderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.func]),
  showLinePoints: _propTypes2.default.bool,
  defined: _propTypes2.default.func,
  lineStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  pointStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  areaStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  lineClass: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  pointClass: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  areaClass: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  canvasPoints: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool]),
  canvasLines: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool]),
  canvasAreas: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool]),
  customPointMark: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  customLineMark: _propTypes2.default.func,
  customAreaMark: _propTypes2.default.func,
  lineIDAccessor: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  minimap: _propTypes2.default.object
});

var ordinalframeproptypes = exports.ordinalframeproptypes = _extends({}, sharedframeproptypes, {
  data: _propTypes2.default.array,
  oScaleType: _propTypes2.default.func,
  rScaleType: _propTypes2.default.func,
  oExtent: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  rExtent: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  invertO: _propTypes2.default.bool,
  invertR: _propTypes2.default.bool,
  oAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  rAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  oPadding: _propTypes2.default.number,
  projection: _propTypes2.default.oneOf(["vertical", "horizontal", "radial"]),
  type: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.func]),
  summaryType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  connectorType: _propTypes2.default.func,
  tooltipContent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  baseMarkProps: _propTypes2.default.object,
  dataAccessor: _propTypes2.default.func,
  rBaseline: _propTypes2.default.number,
  sortO: _propTypes2.default.func,
  pixelColumnWidth: _propTypes2.default.number,
  dynamicColumnWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  renderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.object]),
  summaryRenderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.object]),
  connectorRenderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.object]),
  style: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  connectorStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  summaryStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  canvasPieces: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  canvasConnectors: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  canvasSummaries: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  summaryPosition: _propTypes2.default.func,
  oLabel: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object]),
  pieceIDAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  pieceHoverAnnotation: sharedframeproptypes.hoverAnnotation,
  summaryHoverAnnotation: sharedframeproptypes.hoverAnnotation,
  axis: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  ordinalAlign: _propTypes2.default.string
});

var networkframeproptypes = exports.networkframeproptypes = _extends({}, sharedframeproptypes, (_extends2 = {
  nodes: _propTypes2.default.array,
  edges: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  graph: _propTypes2.default.object,
  nodeIDAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  sourceAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  targetAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  nodeSizeAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
  customNodeIcon: _propTypes2.default.func,
  customEdgeIcon: _propTypes2.default.func,
  nodeRenderKey: _propTypes2.default.func,
  edgeRenderKey: _propTypes2.default.func,
  edgeRenderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  nodeRenderMode: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  canvasEdges: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  canvasNodes: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  nodeLabels: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  edgeWidthAccessor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  networkType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  renderFn: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  nodeStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  edgeStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
}, _defineProperty(_extends2, "customNodeIcon", _propTypes2.default.func), _defineProperty(_extends2, "zoomToFit", _propTypes2.default.bool), _defineProperty(_extends2, "edgeType", _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])), _extends2));


//////////////////
// WEBPACK FOOTER
// ./node_modules/semiotic/lib/constants/frame_props.js
// module id = 330
// module chunks = 0